import React, { PropTypes, Component } from 'react';
import { bindActionCreators } from 'redux';
import moment from 'moment';

import { settingsModel } from '../../../models/service/settings.model';
import { alertModel } from '../../../models/core/alert.model';
import { clearAlertToJump } from '../../../actions/alert.actions';
import { composeSpinner } from '../../../hoc/composeSpinner';

import { DATEPICKER_FORMAT, REFRESH_TIMEOUT_10_SEC } from '../../../constants/data.constant';
import { alertsDataDirection as direction } from '../../../services/core/alerts/alerts.constant';
import { getMaxDate, getMinDate } from '../../../services/core/alerts/alerts.helper';
import { errors, getDetails } from '../../../services/core/alerts/alert.selectors';
import { getCurrentDate } from '../../../services/service/settings.selectors';
import debounce from '../../../utils/debounce';

let timerId = null;

class AlertContainer extends Component {

    constructor(props) {
        super(props);

        this._getCurrentDate = () => {
            return this.state.date || this.props.currentDate;
        };

        this._refreshLoadPrev = (pause = REFRESH_TIMEOUT_10_SEC) => {
            clearTimeout(timerId);
            timerId = setTimeout(this.handleGetPrev, pause);
        };

        this._loadFull = (clear = true, date = null) => {
            this._refreshLoadPrev();

            const {
                details,
                handleClearDetails,
                handleGetDetails
            } = this.props;
            const { showImportant } = this.state;

            if (!details.isLoading) {
                clear && handleClearDetails();
                date = date || this._getCurrentDate();

                handleGetDetails({
                    date,
                    showImportant,
                    alertsDataDirection: direction.UP_DOWN
                });
            }
        };

        this._loadNext = (clear = true, date = null) => {
            this._refreshLoadPrev();

            const {
                details,
                handleClearDetails,
                handleGetDetails
            } = this.props;
            const { showImportant } = this.state;

            if (!details.isLoading) {
                clear && handleClearDetails();
                date = date || getMinDate(this._getCurrentDate(), clear ? null : details);
                handleGetDetails({
                    date,
                    showImportant,
                    alertsDataDirection: direction.DOWN
                });
            }
        };

        this._loadPrev = (clear = true, date = null) => {
            this._refreshLoadPrev();

            const {
                details,
                handleClearDetails,
                handleGetDetails
            } = this.props;
            const { showImportant } = this.state;

            if (!details.isLoading) {
                clear && handleClearDetails();
                date = date || getMaxDate(this._getCurrentDate(), clear ? null : details);
                handleGetDetails({
                    date,
                    showImportant,
                    alertsDataDirection: direction.UP
                });
            }
        };

        this.handleAlertsToggle = groupedItem => {
            const { alertsToggled } = this.state;
            const index = alertsToggled.indexOf(groupedItem.index);

            if (index < 0) {
                this.setState({
                    alertsToggled: [...alertsToggled, groupedItem.index]
                });
            } else {
                this.setState({
                    alertsToggled: [...alertsToggled.slice(0, index), ...alertsToggled.slice(index + 1)]
                });
            }
        };

        this.handleGetNext = () => {
            this.startTime();
            this._loadNext(false);
        };

        this.handleGetPrev = () => {
            this.startTime();
            this._loadPrev(false);
        };

        this.handleToggleShowImportant = () => {
            const { showImportant } = this.state;
            this.setState({
                showImportant: !showImportant,
                alertsToggled: []
            });
        };

        this.handleDateChange = newDate => {
            const date = moment(newDate, DATEPICKER_FORMAT).toDate();
            date.setHours(0, 0, 0, 0);
            this.setState({
                date
            });
        };

        this.state = {
            date: null,
            showImportant: false,
            alertsToggled: []
        };

        this._loadPrevDebounce = this._loadPrev; //debounce(this._loadPrev, 500).bind(this);
        this._loadNextDebounce = this._loadNext; //debounce(this._loadNext, 500).bind(this);
    }

    componentDidMount() {
        setTimeout(() => {
            this._loadFull(false);
        }, 0);
    }

    componentDidUpdate(prevProps, prevState) {
        const { date, showImportant } = this.state;

        if (date !== prevState.date || showImportant !== prevState.showImportant) {
            this.startTime();
            this._loadFull(true, date);
        }

        if (this.props.alertReducer.alertToJump.alert) {
            this.handleAlertsToggle(this.props.alertReducer.alertToJump.alert);
            this.props.handleClearAlertToJump();
        }

        if (prevProps.details.isLoading && !this.props.details.isLoading) {
            this.clearSpinner();
        }
    }

    componentWillUnmount() {
        clearTimeout(timerId);
        timerId = null;
        this.props.handleClearAlertToJump();
    }

    render() {
        return null;
    }
}
export const AlertContainerCore = composeSpinner(AlertContainer);

export const mapStateToPropsCore = (state, props) => {
    const { details } = getDetails(state);
    const currentDate = getCurrentDate(state);

    return {
        alertModel,
        settings: state.settings[settingsModel.MODEL_NAME],
        errors: errors(state).items,
        isErrors: errors(state).isNetworkError,
        details,
        currentDate,
        alertReducer: state.alertReducer
    };
};

export const mapDispatchToPropsCore = modelGet => dispatch => {
    return {
        handleGetDetails: bindActionCreators(modelGet(alertModel), dispatch),
        handleClearDetails: bindActionCreators(alertModel.actionClear.bind(null, alertModel), dispatch),
        handleClearAlertToJump: bindActionCreators(clearAlertToJump, dispatch)
    };
};


// WEBPACK FOOTER //
// ./~/pluton-core/lib/containers/pages/core/Alert.container.js